import { formatDate } from '../core/utils/date-fns-utils';
import { getClientTimezoneValue } from '../core/utilities';

export interface DateRangeInterface {
  from: string;       //date in 'yyyy-MM-dd'-format
  to: string;         //date in 'yyyy-MM-dd'-format
  timezone: string;
}

/**
 * Contains from- and to-dates in 'yyyy-MM-dd'-format and the local timezone.
 * Can be used to send daterange-filters in the body of BE requests.
 */
export class DateRange implements DateRangeInterface {
  from: string;       //date in 'yyyy-MM-dd'-format
  to: string;         //date in 'yyyy-MM-dd'-format
  timezone: string;   //timezone, e.g. "Europe/Vienna"

  /**
   * Returns a new DaterangePayload from 2 dates
   * @param fromDate Start of the daterange.
   * @param toDate End of the daterange.
   */
  static generate(fromDate: string | Date, toDate: string | Date): DateRangeInterface {
    // TODO: should be just string after refactoring QA and INSIGHTS
    return {
      from: fromDate ? fromDate instanceof Date ? formatDate(fromDate, 'yyyy-MM-dd') : fromDate : null,
      to: toDate ? toDate instanceof Date ? formatDate(toDate, 'yyyy-MM-dd') : toDate : null,
      timezone: getClientTimezoneValue(),
    };
  }
}

/**
 * Returns a new DaterangePayload from 2 date strings
 * @param from Start of the daterange in 'yyyy-MM-dd' format.
 * @param to End of the daterange in 'yyyy-MM-dd' format.
 */
export function generateDateRange(from: string, to: string): DateRangeInterface {
  return {
    from,
    to,
    timezone: getClientTimezoneValue(),
  };
}